import qs from "qs";
import axios from "axios";
import { Dialog, Toast } from "vant";
import { BASE_URL, REDIRECT_URI } from "../config/global.js";

axios.defaults.timeout = 30000; // 请求超时
axios.defaults.headers.post["Content-Type"] = "application/x-www-form-urlencoded;charset=UTF-8";
// axios.defaults.withCredentials = true; // 允许跨域携带cookie
// axios.defaults.headers.get['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';

function getWecomOauthUrl() {
  return `${BASE_URL}/api/index/qw_login?redirect_uri=${encodeURIComponent(REDIRECT_URI)}`;
}

// 添加请求拦截器
axios.interceptors.request.use(
  function(config) {
    // 获取localStorage 内token
    const token = localStorage.getItem("token");
    // const token = "%7B%22alg%22%3A%22HS256%22%2C%22typ%22%3A%22JWT%22%7D.%7B%22openid%22%3A%22ou_7dd43832a60de4b2b5679170929dad52%22%2C%22modbile%22%3A%22u-2Nhk4u44xbWrNYHGomWT9Ch5h16g4143i8000lA02LqP%22%2C%22expireTime%22%3A1653209853%7D.%257B%2522alg%2522%253A%2522HS256%2522%252C%2522typ%2522%253A%2522JWT%2522%257D%257B%2522openid%2522%253A%2522ou_7dd43832a60de4b2b5679170929dad52%2522%252C%2522modbile%2522%253A%2522u-2Nhk4u44xbWrNYHGomWT9Ch5h16g4143i8000lA02LqP%2522%252C%2522expireTime%2522%253A1653209853%257D111HS256";
    if (!isEmpty(token)) {
      config.headers["Authorization"] = "Bearer " + token; // 如果token 存在则携带token访问
    }

		let stoToken = window.localStorage.getItem("sto_user_token");
		console.log('fclst', stoToken);
		console.log('fclt', token);
    
    if (stoToken) {
      config.headers["token"] = stoToken;
    }

    return config;
  },
  function(error) {
    // 对请求错误做些什么
    return Promise.reject(error);
  }
);

// 添加响应拦截器
axios.interceptors.response.use(
  function(res) {
    // sto    token失效
    if (res.data.code == 10401 ) {
      // 企业微信对接：token 失效后自动发起 OAuth，不再依赖弹窗确认
      window.localStorage.removeItem("sto_user_token");
      window.localStorage.setItem("redirect_url", window.location.href);
      window.location.href = getWecomOauthUrl();
      return;
    }

    if (res.data.code == 10403) {
      Dialog.alert({
        title: "权限不足",
        message: res.data.msg,
      }).then(() => {
        // console.log(res)
        // window.location.href = REDIRECT_URI
      });
      return Promise.reject(res);
    }

    return res;
  },
  function(err) {
    const errData = (err && err.response && err.response.data) || (err && err.data) || {};

    if (errData.code == 401 && errData.msg == "generate access_token fail") {
      window.localStorage.removeItem("sto_user_token");
      window.localStorage.setItem("redirect_url", window.location.href);
      window.location.href = getWecomOauthUrl();
      return Promise.reject(err);
    }
    if (errData.code == 401) {
      Toast(errData.msg || "请求失败");
    } else if (!errData.code) {
      Toast("网络异常，请稍后重试");
    }
    // 对响应错误做点什么
    return Promise.reject(err);
  }
);

/*对象转json*/
export function toJson(data) {
  var json = qs.stringify(data);
  return json;
}

/*判断是否为空*/
export function isEmpty(str) {
  if (str === "" || str === null || str === undefined) {
    return true;
  }
  return false;
}

/**
 * get方法，对应get请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function get(url, params) {
  return new Promise((resolve, reject) => {
    axios
      .get(url, {
        params: params,
      })
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject((err && err.response && err.response.data) || (err && err.data) || err);
      });
  });
}

export function put(url, params) {
  return new Promise((resolve, reject) => {
    axios
      .put(url, {
        params: params,
      })
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject((err && err.response && err.response.data) || (err && err.data) || err);
      });
  });
}

export function deletes(url, params) {
  return new Promise((resolve, reject) => {
    axios
      .delete(url, {
        params: params,
      })
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject((err && err.response && err.response.data) || (err && err.data) || err);
      });
  });
}
/**
 * post方法，对应post请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function post(url, params) {
  return new Promise((resolve, reject) => {
    axios
      .post(url, qs.stringify(params))
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject((err && err.response && err.response.data) || (err && err.data) || err);
      });
  });
}


export async function downFile(url, params, config, filename = '数据模板.xlsx'){
	axios
		.get(url, {
		params,
		headers: {'Content-Type':'application/x-www-form-urlencoded'},
		responseType: 'arraybuffer',
		...config
	})
	.then(async(resp)=> {
		const { data }= resp;
		const url = window.URL.createObjectURL(new Blob([data], { type: 'application/vnd.ms-excel;charset=utf-8' }));
		const link = document.createElement('a');
		link.style.display = 'none';
		link.href = url;
		link.setAttribute('download', filename); // 设置下载的文件名
		document.body.appendChild(link);
		link.click();
		document.body.removeChild(link);
	})
	.catch((e)=> {
		console.log(e	)
	})
	.finally(()=>{
		
	})
}
	//Vue.use(axios)
